import { RootState } from "../../../../store";

export const viewWithoutFiltersResourceTypesSelector = (state: RootState) => {
  return state.account.viewWithoutFiltersResourceTypes;
};
